import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import RoundTable from '../RoundTable/RoundTable';
import { getRoundsLeague } from '../../../api/getRoundsLeague';
import * as func from '../../../utils/funcs';

import styles from './RoundHeader.module.css';
import iconEdit from './../../../graphics/icons/edit.svg';

const calculateInitialRoundNumber = (rounds, roundId) => {

  try {
    const round = parseInt(roundId, 10) === 0 ? 0 :
      rounds.filter(round => round.id === parseInt(roundId, 10))[0] &&
      rounds.filter(round => round.id === parseInt(roundId, 10))[0].round_number;
    return round;
  } catch (error) {
    return 'unknown round';
  }

};

function RoundHeader(props) {
  const { user, leagueId, rounds, setRounds, setMatches } = props;
  const history = useHistory();
  const { roundId } = useParams();
  const [round, setRound] = React.useState(calculateInitialRoundNumber(rounds, roundId));
  //const [isClick, setIsClick] = React.useState(false);
  const isClick = false;
  const [viewAll, setViewAll] = React.useState(false);

  // loaded the Rounds from the API
  React.useEffect(() => {
    let mounted = true;

    getRoundsLeague(leagueId).then(data => {
      if (data.error) {
      } else {
        mounted && setRounds(data.data);
      }
    });

    return function cleanup() {
      mounted = false;
    };
  }, [leagueId, setRounds]);

  // should trigger only on start >> deside which round id to start with
  React.useEffect(() => {
    if (rounds.length > 0 && parseInt(roundId, 10) === 0) {
      // find the closest date to taday
      let closestRound = {
        round_id: '-1', distance: 1000000,
      };
      const todayDate = new Date();

      for (let i = 0; i < rounds.length; i++) {
        let datesDistance = func.datesDistance(rounds[i].round_date, todayDate);
        if (datesDistance < closestRound.distance) {
          closestRound = {
            round_id: rounds[i].id, distance: datesDistance,
          };
        }
      }

      // get the id of this Round & push to this round
      history.push(`/leagues/${leagueId}/rounds/${closestRound.round_id}`);

      // OLD
      //history.push(`/leagues/${leagueId}/rounds/${rounds[0].id}`);
    }
  }, [rounds, history, leagueId, roundId]);

  // when RoundId change edit the round state
  React.useEffect(() => {

    if (parseInt(roundId, 10) !== 0) {
      const newRound = rounds.filter(round => round.id == roundId)[0];
      setRound(newRound?.round_number);
    }
  }, [roundId, rounds, round]);

  const handleClickBack = () => {
    if (round > 1) {
      setRound(r => r - 1);
      setTimeout(() => {
        history.push(`/leagues/${leagueId}/rounds/${rounds[round - 2].id}`);
      }, 500);
    }
  };

  const handleClickNext = () => {
    if (round < rounds.length) {
      setRound(r => r + 1);
      setTimeout(() => {
        history.push(`/leagues/${leagueId}/rounds/${rounds[round].id}`);
      }, 500);
    }
  };

  const handleClickEdit = () => {
    history.push(`/leagues/${leagueId}/rounds/${rounds[round - 1].id}/edit`);
  };

  return <div style={{ position: 'relative', height: '100%' }}>


    {rounds.length > 0 ? (viewAll ? (<div className={styles.allRoundsContainer}>
      {rounds.map(round1 => (<div className={styles.roundCard} key={round1.id}>
        <div className={styles.topic}>
          <div className={styles.text}>
            <div className={styles.roundCount}>מחזור {round1.round_number}</div>
            <div className={styles.roundDate}>
              {func.showDate(round1.round_date)}
              <img
                style={func.validRakazLeague(user) ? { display: 'inline-block' } :
                  { display: 'none' }}
                src={iconEdit}
                alt="עריכת מחזור"
                height="15px"
                onClick={handleClickEdit}
              />
            </div>
          </div>
        </div>
        <div className={styles.table}>
          <RoundTable
            user={user}
            leagueId={leagueId}
            round={round1}
            setMatches={setMatches}
          />
        </div>
      </div>))}
    </div>) : (<div
      id={'rounds-header'}
      className={styles.roundHeader}
      style={{ right: `-${(round - 1) * 100}vw`, paddingTop: '10px' }}
    >
      {rounds.map(round1 => (
        <div className={styles.round} id={'round_num' + round1.id} key={round1.id}>
          <div className={styles.topic}>
            <div
              style={round1.round_number === 1 && !isClick ?
                { display: 'block', visibility: 'hidden' } : { display: 'block' }}
              className={styles.back}
              onClick={handleClickBack}
            />
            <div className={styles.text}>
              <div className={styles.roundCount}>מחזור {round1.round_number}</div>
              <div className={styles.roundDate}>
                {func.showDate(round1.round_date)}
                <p style={{ position: 'relative' }}>
                  <p style={{ position: 'absolute', top: '10px', right: '50%' }}>


                    <img
                      style={func.validRakazLeague(user) ? { display: 'inline-block' } :
                        { display: 'none' }}
                      src={iconEdit}
                      alt="עריכת מחזור"
                      height="20px"
                      onClick={handleClickEdit}
                    />
                  </p>
                </p>
              </div>
            </div>
            <div
              style={round1.round_number === rounds.length && !isClick ?
                { display: 'block', visibility: 'hidden' } : { display: 'block' }}
              className={styles.next}
              onClick={handleClickNext}
            />
          </div>
          <div
            className={styles.table}
            style={func.validRakazLeague(user) ? { marginTop: '10vh' } :
              { marginTop: '3vh' }}
          >
            <RoundTable
              user={user}
              leagueId={leagueId}
              round={round1}
              setMatches={setMatches}
            />
          </div>
        </div>))}
    </div>)) : (<div className={styles.noRoundsContainer}>
      <h1 className={styles.noRoundsHeader}>אין מחזורים רשומים עדיין</h1>
    </div>)}
  </div>;
}

export default RoundHeader;
